import { format } from 'date-fns';
import React from 'react';
import { StyleSheet, Image } from 'react-native';

import { Box, Text } from '@components/Restyle';

import AppLogo from '../../../../assets/images/App.png';

// Define the type for the data prop
interface CoverPageData {
  team?: {
    avatarFile?: {
      url: string;
    };
    name?: string;
  };
  createdAt?: string;
  generatedBy?: string;
}

export const CoverPage = ({ data }: { data: CoverPageData }) => {
  return (
    <Box>
      <Box m='s'>
        <Image source={AppLogo} style={styles.appLogo} />
      </Box>
      <Box marginHorizontal='xs' marginVertical='m' gap='m'>
        <Text
          variant='metadata'
          color='textPrimary'
          fontWeight='400'
          fontSize={12}
          textAlign='left'>
          {data?.createdAt
            ? `Generated on: ${format(
                data?.createdAt || '2025-03-12T05:30:00+05:30',
                'MMMM dd, yyyy'
              )}`
            : ''}
        </Text>
        <Text
          variant='metadata'
          color='textPrimary'
          fontWeight='400'
          fontSize={12}
          textAlign='left'>
          {`by ${data?.generatedBy || ''}`}
        </Text>
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  appLogo: {
    alignSelf: 'flex-start',
    width: 94,
    height: 28,
  },
  companyLogo: {
    alignSelf: 'center',
    width: 376,
    height: 96,
  },
});
